"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * Gets the next element from a "circular array". When the "current" argument is the last element
 * in the baseArr or is undefined, "next" refers to the starting element.
 */

function getNextInCircularArray(baseArr, current) {
  // Get the current element's index. Is -1 if element is not found.
  var typeIndex = baseArr.findIndex(function (t) {
    return t === current;
  });
  var loopSelection = typeIndex === baseArr.length - 1;

  if (loopSelection) {
    return baseArr[0];
  }

  return baseArr[typeIndex + 1];
}

var _default = getNextInCircularArray;
exports.default = _default;